import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: register the SOS Live service worker so the team can install the app
// to their home screen / dock and get an offline shell. Only runs in
// production builds — `yarn start` (dev server) intentionally skips it so
// hot-reload doesn't fight with cached assets.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch(() => {
        /* Registration failures are non-fatal — app still works without it. */
      });
  });
}
